import createIcon from '../../createIcon';

/**
 * @component @name Check
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC43OTUwOCAxNS44NzQ5TDQuNjI1MDggMTEuNzA0OUwzLjIwNTA4IDEzLjExNDlMOC43OTUwOCAxOC43MDQ5TDIwLjc5NTEgNi43MDQ5MkwxOS4zODUxIDUuMjk0OTJMOC43OTUwOCAxNS44NzQ5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Check = createIcon('Check', [
  [
    'path',
    {
      d: 'M8.79508 15.8749L4.62508 11.7049L3.20508 13.1149L8.79508 18.7049L20.7951 6.70492L19.3851 5.29492L8.79508 15.8749Z',
      key: '5stcsf',
    },
  ],
]);

export default Check;
